import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue'

import { formatTime } from '@/utils'
import { getStoreWarning } from '@/api/shop'
import { IWarningInfo } from '@/utils/interface'
import warningItem from '@/components/WarningItem/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  storeNo: {
    type: String,
    required: true
  },
  date: {
    type: String,
    default() {
      return ''
    }
  },
  start: {
    type: String,
    default() {
      return ''
    }
  },
  end: {
    type: String,
    default() {
      return ''
    }
  }
},
  setup(__props) {

const props = __props

const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const curPage = ref(1)
const curSize = ref(20)
const list = ref<IWarningInfo[]>([])



watch([() => props.start, () => props.storeNo], () => {
  refreshing.value = true
  onRefresh()
})

const onLoad = () => {
  if (refreshing.value) {
    list.value = []
    refreshing.value = false
    curPage.value = 1
  }
  setTimeout(() => {
    getStoreWarning({
      storeNo: props.storeNo,
      startTime: props.start,
      endTime: props.end,
      page: curPage.value,
      size: curSize.value
    }).then((res: any) => {
      if (curPage.value === 1) {
        list.value = res.warningInfoList
      } else {
        list.value = list.value.concat(res.warningInfoList)
      }
      loading.value = false

      if (list.value.length >= res.row) {
        finished.value = true
      } else {
        curPage.value += 1
      }
    })
  }, 1000)
}

const onRefresh = () => {
  // 清空列表数据
  finished.value = false

  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  onLoad()
}

return (_ctx: any,_cache: any) => {
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_divider, { style: { color: '#D1D1D1', borderColor: '#D1D1D1', margin: '12px 54px' } }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.date ? __props.date : _unref(formatTime)(+new Date(), 'date')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          class: "warning-list",
          offset: "5",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            _createVNode(warningItem, { list: list.value }, null, 8, ["list"])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})